import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionEmpresaConceptosEditarComponent {
  data
  idProyecto
  onClose
  onEditar

  constructor (ViaticosProyectosProyectoConceptos) {
    this.ViaticosProyectosProyectoConceptos = ViaticosProyectosProyectoConceptos
  }

  editar () {
    this.ViaticosProyectosProyectoConceptos.post(this.idProyecto, this.data)
      .then(() => {
        this.onEditar({$event: {data: this.data}})
        this.onClose()
      })
  }
}

module.component('viaticosConfiguracionEmpresaConceptosEditar', {
  controller: ViaticosConfiguracionEmpresaConceptosEditarComponent,
  template,
  bindings: {
    data: '<',
    idProyecto: '<',
    onClose: '&',
    onEditar: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/empresa/conceptos/editar/component.js